import Box from "@mui/material/Box";
import Card from "@mui/material/Card";
import CardHeader from "@mui/material/CardHeader";
import CardContent from "@mui/material/CardContent";
import {
  Grid,
  TextField,
  RadioGroup,
  FormControlLabel,
  Radio,
  FormLabel,
  FormControl,
  Button,
} from "@mui/material";
import { useState } from "react";
import { IVISAxios } from "../../Modules/Axios/IVISAxios";

const RetiredCarInfo = ({ vehicleData, inquiryHandler }) => {
  const [retiredCarData, setRetiredCarData] = useState({
    isPreDisposal: vehicleData.preDisposal ?? false,
    agedVehicleVin: vehicleData.agedVehicleVin ?? "",
    agedVehicleRegNo: vehicleData.agedVehicleRegNo ?? "",
    agedVehicleSalesDate: vehicleData.agedVehicleRegDate ?? "",
    ownershipNow: vehicleData.ownershipNow ?? true,
    deregistrationDate: vehicleData.deregistrationDate ?? "",
  });

  const handleChange = (field) => (e) => {
    const getInputValue = (target) => {
      if (target.type === "checkbox") return target.checked;
      if (target.type === "number") return Number(target.value);
      return target.value;
    };

    setRetiredCarData((prev) => ({
      ...prev,
      [field]: getInputValue(e.target),
    }));
  };

  const handleSubmit = async () => {
    if (
      !retiredCarData.agedVehicleVin ||
      !retiredCarData.agedVehicleRegNo ||
      !retiredCarData.agedVehicleSalesDate
    ) {
      alert("필수 입력값을 입력해주세요.");
      return;
    }
    try {
      const result = await IVISAxios.patch("/aged-vehicle", {
        vin: vehicleData.vin,
        crn: vehicleData.crn,
        reducedVat: vehicleData.reducedVat,
        bizDropSiteNo: "124-81-83835",
        customs: "평택",
        ...retiredCarData,
      });
      if (result.status !== 200) {
        alert("등록 실패했습니다.");
        return;
      }
      alert("등록 완료되었습니다.");
      inquiryHandler();
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <Box>
      <Card variant="outlined" sx={{ borderRadius: 3 }}>
        <CardHeader title={"노후차정보"} sx={{ backgroundColor: "#eee" }} />
        <CardContent>
          <Box
            sx={{ display: "flex", flexDirection: "column", flex: 1, gap: 2 }}
          >
            <Grid container spacing={1}>
              <Grid item xs={12} sm={6}>
                <FormControl component="fieldset" sx={{ width: "100%" }}>
                  <FormLabel
                    component="legend"
                    sx={{
                      position: "absolute",
                      top: "-10px",
                      left: "10px",
                      backgroundColor: "#fff",
                      padding: "0 5px",
                      fontSize: "0.8rem",
                    }}
                  >
                    사전폐차여부
                  </FormLabel>
                  <RadioGroup
                    row
                    sx={{
                      border: "1px solid #ccc",
                      borderRadius: 1,
                      px: 2,
                      py: 0.5,
                    }}
                    value={retiredCarData.isPreDisposal ? "yes" : "no"}
                    onChange={(e) =>
                      setRetiredCarData((prev) => ({
                        ...prev,
                        isPreDisposal: e.target.value === "yes",
                      }))
                    }
                  >
                    <FormControlLabel
                      value="yes"
                      control={<Radio />}
                      label="예"
                    />
                    <FormControlLabel
                      value="no"
                      control={<Radio />}
                      label="아니오"
                    />
                  </RadioGroup>
                </FormControl>
              </Grid>
              <Grid item xs={12} sm={6}>
                <FormControl component="fieldset" sx={{ width: "100%" }}>
                  <FormLabel
                    component="legend"
                    sx={{
                      position: "absolute",
                      top: "-10px",
                      left: "10px",
                      backgroundColor: "#fff",
                      padding: "0 5px",
                      fontSize: "0.8rem",
                    }}
                  >
                    24.12.31현재 소유여부
                  </FormLabel>
                  <RadioGroup
                    row
                    sx={{
                      border: "1px solid #ccc",
                      borderRadius: 1,
                      px: 2,
                      py: 0.5,
                    }}
                    value={
                      retiredCarData.ownershipNow ?? vehicleData.ownershipNow
                        ? "yes"
                        : "no"
                    }
                    onChange={(e) =>
                      setRetiredCarData((prev) => ({
                        ...prev,
                        ownershipNow: e.target.value === "yes",
                      }))
                    }
                  >
                    <FormControlLabel
                      value="yes"
                      control={<Radio />}
                      label="예"
                    />
                    <FormControlLabel
                      value="no"
                      control={<Radio />}
                      label="아니오"
                    />
                  </RadioGroup>
                </FormControl>
              </Grid>
            </Grid>

            <Grid container spacing={1}>
              <Grid item xs={12} sm={6}>
                <TextField
                  label="노후차 차대번호"
                  value={retiredCarData.agedVehicleVin}
                  onChange={handleChange("agedVehicleVin")}
                  fullWidth
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  label="노후차 자동차등록번호"
                  value={retiredCarData.agedVehicleRegNo}
                  onChange={handleChange("agedVehicleRegNo")}
                  fullWidth
                />
              </Grid>
            </Grid>
            <Grid container spacing={1}>
              <Grid item xs={12} sm={6}>
                <TextField
                  label="노후차 최초등록일"
                  type="date"
                  value={
                    retiredCarData.agedVehicleSalesDate ||
                    vehicleData.agedVehicleRegDate
                  }
                  onChange={handleChange("agedVehicleSalesDate")}
                  fullWidth
                  InputLabelProps={{ shrink: true }}
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  label="말소등록일"
                  type="date"
                  value={retiredCarData.deregistrationDate}
                  onChange={handleChange("deregistrationDate")}
                  fullWidth
                  InputLabelProps={{ shrink: true }}
                />
              </Grid>
            </Grid>
            <Button variant="contained" onClick={handleSubmit}>
              노후차 정보 등록
            </Button>
          </Box>
        </CardContent>
      </Card>
    </Box>
  );
};

export default RetiredCarInfo;
